export default __webpack_public_path__ + "static/media/Product-List.921b7167.jpg";